import { render } from "./SettingsBranding.vue?vue&type=template&id=146a57f0"
import script from "./SettingsBranding.vue?vue&type=script&lang=js"
export * from "./SettingsBranding.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__